import { render } from "./Footer.vue?vue&type=template&id=907c6af8"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=907c6af8&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__